<template>
  <panel class="event">
    <el-row class="header">
      <el-col>
        <h1>{{ $t(title) }}</h1>
      </el-col>
    </el-row>

    <el-row>
      <template v-if="events.length > 0">
        <el-col :span="18" class="sub-heading">{{ getNameCol }}</el-col>
        <el-col :span="6" class="sub-heading">{{ getValueCol }}</el-col>
      </template>
      <template v-else>
        <el-col :span="24" class="sub-heading">
          {{ $t('EventPanel_NoEvents') }}
        </el-col>
      </template>
    </el-row>
    <el-row v-for="(event, index) in events" :key="index" class="event-row">
      <el-col :span="18">
        <el-tooltip :open-delay="600" :content="event.name" placement="top">
          <p>
            {{ event.name }}
          </p>
        </el-tooltip>
      </el-col>
      <el-col :span="6"><metric :metric="event.value"/></el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button type="text" @click="showMoreRoute" v-if="route">
          <p class="option">{{ $t('EventPanel_ViewMore') }}</p>
        </el-button>
      </el-col>
    </el-row>
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
import Metric from '@/common/components/Metric'

export default {
  name: 'EventPanel',

  components: { Metric, Panel },

  props: {
    title: {
      type: String,
      required: true
    },
    events: {
      type: Array,
      required: true
    },
    nameCol: {
      type: String
    },
    valueCol: {
      type: String
    },
    route: {
      type: String
    }
  },

  computed: {
    getNameCol() {
      return this.nameCol ? this.nameCol : this.$t('EventPanel_EventName')
    },
    getValueCol() {
      return this.valueCol ? this.valueCol : this.$t('EventPanel_EventHits')
    }
  },

  methods: {
    showMoreRoute() {
      this.$router.push(this.route)
    }
  }
}
</script>

<style scoped>
.event {
  width: 536px;
}

h1 {
  font-weight: 600;
  color: #1d87c8;
}

.header {
  padding-bottom: 20px;
}

.sub-heading {
  color: #808080;
  padding-bottom: 8px;
}

.event-row >>> p {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  line-height: 15px;
  font-size: 12px;
  color: #333333;
}

.event-row {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}

.option {
  text-decoration: underline;
  font-weight: 400;
  color: #0e90d2;
  font-size: 12px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/common/components/dashboard/EventPanel.vue